import Cart from "../models/cart";
import {useNavigate, useParams} from "react-router";
import Skeleton from 'react-loading-skeleton'
import {useTranslation} from "react-i18next";
import {mustache} from "../Helpers/functions";
import {DynamicObject} from "../models/General";
import Navbar from "../components/Navbar/Navbar";
import {emptyCart, emptyPayment, summary} from "../Constants/defaultData";
import 'react-loading-skeleton/dist/skeleton.css'
import useHttp from "../Hooks/use-http/use-http";
import {configCreatePaymentApi, configGetCartApi} from "../Api/api.config";
import {Col, Container, Row} from "react-bootstrap";
import axios, {AxiosError, AxiosResponse} from "axios";
import CartSummary from "../components/Cart/CartSummary/CartSummary";
import React, {useCallback, useEffect, useState} from "react";
import CartItemsList from "../components/Cart/CartItemsList/CartItemsList";
import CouponForm from "../components/Coupon/CouponForm/CouponForm";
import PurchaseButton from "../components/PurchaseButton/PurchaseButton";
import PaymentItemsList from "../components/PaymentItems/PaymentItemsList";
import Payment from "../models/payment";
import style from "../components/PaymentItems/Payment.module.css";
import PaymentFooter from "../components/PaymentItems/PaymentFooter";
import {logOrderCartReviewView } from "../logging/helpers/commonLoggingFunctions";
import { updateScreenHistory } from "../logging/helpers/updateScreenHistory";
import Summary from "../models/summary";
import CartSummaryView from "../components/Cart/CartSummary/CartSummaryView";


const SelectPayment = () => {

    const [loading, setLoading] = useState<boolean>(false)
    let {memberId, cartId, identification} = useParams();
    const {t} = useTranslation();
    const [payment, setPayment] = useState<Payment>(emptyPayment)
    const [cartSummary, setCartSummary] = useState<Summary>(summary)
    const navigate=useNavigate()


    /*-----------------------------
    *           REQUEST
    * ----------------------------*/
    const createPaymentHttp = useHttp<DynamicObject>(configCreatePaymentApi)
    const requestCreatePayment = createPaymentHttp.request

    createPaymentHttp.request = useCallback((args) => {
        const success = (response: AxiosResponse) => {
            localStorage.setItem('countryCode', response.data.cartSummary.countryCode)
            setPayment(response.data.payment)
            // setCart(response.data.cart)
            setCartSummary(response.data.cartSummary)
            setLoading(false)
            //logging
            if(cartId && parseInt(cartId)){
                updateScreenHistory('order_method');
            }
            //
        }
        const error = (response: AxiosError) => {
            setLoading(false)
            navigate(process.env.REACT_APP_404_REDIRECT)
        }

        requestCreatePayment({
            config: {
                memberId: memberId,
                cartId: cartId,
                identification: identification,

            },
            callbacks: {
                success,
                error,
            }
        })
    }, [cartId, identification, memberId])

    /*-----------------------------
    *           FUNCTIONS
    * ----------------------------*/


    const reloadPayment = (payment: Payment) => {
        setPayment(payment)
    }
    /*-----------------------------
    *           EFFECTS
    * ----------------------------*/
    useEffect(() => {

        setLoading(true)
        createPaymentHttp.request()
    }, [cartId, identification, memberId])

    return (
        <div>
            <div className={`${style.blocked_background}`} id={'background-popup'}>
            </div>
            <Container className={`sm-pad-zero`}>
                <Row className={`justify-content-center`}>
                    <Col lg={6} md={8} sm={10}>
                        <Navbar  loading={loading} title={t('page.payment.title')}
                                subTitle={mustache(t('page.payment.subtitle'), {cartId: cartSummary.cartId})}/>

                        <PaymentItemsList  payment_secret={payment.payment_secret}  loading={loading} cartSummary={cartSummary} cartId={cartSummary.cartId}
                                          items={payment.available_methods}/>

                        <div style={{padding:"15px",backgroundColor: "#F2F2F7",  margin: "0px 8px 0" }}>
                            <div style={{backgroundColor: "#FFFFFF",borderRadius:"15px"}}>
                                <CartSummary title={'total.cart.title'}  reloadPayment={reloadPayment} shortCartSummary={false} loading={loading} withCoupon={false} summary={cartSummary}/>
                            </div>
                        </div>

                        <PaymentFooter loading={loading} lines={payment.footer}/>

                    </Col>

                </Row>
            </Container>

        </div>
    )
}
export default SelectPayment